// SLED-87: restore when J.P. Morgan signoff lands. Delete the temporary copy below this block, then uncomment the block.
// import type { JSX } from 'react';
// import { PRICING_PREVIEW_CONTENT } from '@/enterprise/features/extendedNetworkFinance/content/sharedContent';
//
// const PricingPreview = (): JSX.Element => (
//   <div className="space-y-6">
//     <p className="text-center text-3xl">{PRICING_PREVIEW_CONTENT.title}</p>
//
//     <div className="rounded-xl bg-white p-6 text-center shadow-sm">
//       <p className="text-2xl font-bold">{PRICING_PREVIEW_CONTENT.rate}</p>
//       <p className="text-base text-text-secondary">{PRICING_PREVIEW_CONTENT.subtitle}</p>
//       <p className="mt-4 text-base">{PRICING_PREVIEW_CONTENT.description}</p>
//     </div>
//
//     <p className="text-center text-xs italic text-text-secondary">{PRICING_PREVIEW_CONTENT.disclaimer}</p>
//   </div>
// );
//
// export default PricingPreview;

import type { JSX } from 'react';
import { PRICING_PREVIEW_CONTENT } from '@/enterprise/features/extendedNetworkFinance/content/sharedContent';

const PricingPreview = (): JSX.Element => (
  <div className="space-y-6">
    <p className="text-center text-3xl">{PRICING_PREVIEW_CONTENT.title}</p>

    <div className="rounded-xl bg-white p-6 text-center shadow-sm">
      <p className="text-2xl font-bold">{PRICING_PREVIEW_CONTENT.rate}</p>
      <p className="text-base text-text-secondary">{PRICING_PREVIEW_CONTENT.subtitle}</p>
      <p className="mt-4 text-base">{PRICING_PREVIEW_CONTENT.description}</p>
    </div>

    <p className="text-center text-xs italic text-text-secondary">{PRICING_PREVIEW_CONTENT.monduDisclaimer}</p>
  </div>
);

export default PricingPreview;
